import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { LANGUAGES, useTranslation } from '@/i18n';
import { Icons } from '@/utils/Icons';
import GlobeIcon from './GlobeIcon';

/** Header globe button with the language menu; the choice is saved in localStorage. */
const LanguageSwitcher = ({ className = '' }: { className?: string }) => {
  const { language, setLanguage, t } = useTranslation();

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          title={t('language.select')}
          aria-label={t('language.select')}
          className={`flex size-9 shrink-0 items-center justify-center rounded-md border border-shell-border text-shell-muted transition hover:border-gold hover:text-shell-fg data-[state=open]:border-gold ${className}`}
        >
          <GlobeIcon className="size-6 text-shell-fg" />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={5}
          className="z-50 min-w-[200px] rounded-lg border border-shell-border bg-shell-panel p-1 shadow-dropdown"
        >
          <DropdownMenu.Label className="px-3 pb-1 pt-2 text-xs font-semibold uppercase tracking-wide text-shell-muted">
            {t('language.select')}
          </DropdownMenu.Label>
          <DropdownMenu.RadioGroup
            value={language}
            onValueChange={(code) => {
              const next = LANGUAGES.find((item) => item.code === code);
              if (next) setLanguage(next.code);
            }}
          >
            {LANGUAGES.map((item) => (
              <DropdownMenu.RadioItem
                key={item.code}
                value={item.code}
                className="flex cursor-pointer items-center gap-2 rounded-md px-3 py-1.5 text-sm text-shell-fg/90 outline-none data-[highlighted]:bg-shell-raised data-[state=checked]:text-gold"
              >
                <span className="flex-1">{item.name}</span>
                {item.nativeName !== item.name && (
                  <span lang={item.code} className="text-xs text-shell-muted">
                    {item.nativeName}
                  </span>
                )}
                <DropdownMenu.ItemIndicator>
                  <Icons.Check className="size-4" />
                </DropdownMenu.ItemIndicator>
              </DropdownMenu.RadioItem>
            ))}
          </DropdownMenu.RadioGroup>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default LanguageSwitcher;
